import React, { useState } from 'react'
import { Spin } from 'antd'
import { useDiagram } from '../DiagramContext'
import { useComponentPinout, useComponentFullPinout } from '../../BlockDiagram'
import PinoutTable from './PinoutTable'
import { Loadable } from '../../components/Loading'
import { useTools } from '../../hooks/RelatedContent'
import { useUserInfo } from '../../hooks/User'

const ConnectorSinglePinInfo = ({ isAllPins, setIsAllPins, pageSize }) => {
  const { userInfo } = useUserInfo()
  const isRelatedContentEnabled = userInfo?.features?.related_content ?? false
  const diagram = useDiagram()
  const { isLoading, isSuccess, pinout } = useComponentPinout({
    vin: diagram.vin,
    componentId: diagram.detailDiagram.data.componentId,
    neighborIds: diagram.detailDiagram.data.neighborIds,
  })
  const {
    isLoading: toolsLoading,
    isSuccess: toolsSuccess,
    tools,
  } = useTools({
    vin: diagram.vin,
    componentId: diagram.detailDiagram.data.componentId,
    enabled: isRelatedContentEnabled,
  })

  return (
    <>
      <Loadable showText={false} isLoading={isLoading || !isSuccess}>
        <PinoutTable
          pinout={
            pinout
              ? pinout.filter(
                  (pinout_data) =>
                    pinout_data.pin === diagram.detailDiagram.data.pin,
                )
              : []
          }
          isLoading={isLoading}
          isAllPins={isAllPins}
          setIsAllPins={setIsAllPins}
          pageSize={pageSize}
          tools={tools}
          toolsLoading={toolsLoading}
        />
      </Loadable>
    </>
  )
}

const ConnectorFullPinout = ({ isAllPins, setIsAllPins, pageSize }) => {
  const { userInfo } = useUserInfo()
  const isRelatedContentEnabled = userInfo?.features?.related_content ?? false
  const diagram = useDiagram()
  const { isLoading, pinout } = useComponentFullPinout({
    vin: diagram.vin,
    componentId: diagram.detailDiagram.data.componentId,
  })
  const {
    isLoading: toolsLoading,
    isSuccess: toolsSuccess,
    tools,
  } = useTools({
    vin: diagram.vin,
    componentId: diagram.detailDiagram.data.componentId,
    enabled: isRelatedContentEnabled,
  })

  return (
    <PinoutTable
      pinout={pinout}
      isLoading={isLoading}
      isAllPins={isAllPins}
      setIsAllPins={setIsAllPins}
      pageSize={pageSize}
      tools={tools}
      toolsLoading={toolsLoading}
    />
  )
}

const ConnectorPinout = ({ pageSize }) => {
  const [isAllPins, setIsAllPins] = useState(false)
  return isAllPins ? (
    <ConnectorFullPinout
      isAllPins={isAllPins}
      setIsAllPins={setIsAllPins}
      pageSize={pageSize}
    />
  ) : (
    <ConnectorSinglePinInfo
      isAllPins={isAllPins}
      setIsAllPins={setIsAllPins}
      pageSize={pageSize}
    />
  )
}

export default ConnectorPinout
